export default {"src":"/_next/static/media/chats.810834e1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};